"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Polyfill_1 = require("./polyfill/Polyfill");
Polyfill_1.Polyfill.ensureEnabled();
tslib_1.__exportStar(require("./lib/AsyncContext"), exports);
//# sourceMappingURL=index.js.map